// extracted by css-extract-rspack-plugin
export default {"container":"BlockWrapper-module__container___i9MEf"};